import getServiceName from '../getServiceName';
const maxThrottleDelay = 30000; // 30 seconds.
const throttles = {};
const resolveThrottle = serviceName => {
  if (!serviceName) {
    return;
  }
  const throttle = throttles[serviceName];
  if (!throttle || throttle.complete) {
    return;
  }
  throttle.complete = true;
  clearTimeout(throttle.timerId);
  throttle.resolve();
};
export const throttleGate = config => {
  var _config$signal;
  const serviceName = getServiceName(config);
  if (!serviceName) {
    return Promise.resolve(config);
  }
  (_config$signal = config.signal) === null || _config$signal === void 0 ? void 0 : _config$signal.addEventListener('abort', () => {
    resolveThrottle(serviceName);
  }, {
    once: true
  });
  if (config.disableNovaServiceThrottle) {
    return Promise.resolve(config);
  }
  if (throttles[serviceName]) {
    return throttles[serviceName].promise.then(() => config);
  }
  let resolve;
  const promise = new Promise(res => {
    resolve = res;
  });
  throttles[serviceName] = {
    promise,
    complete: false,
    resolve: resolve,
    timerId: window.setTimeout(() => {
      resolveThrottle(serviceName);
    }, maxThrottleDelay)
  };
  return Promise.resolve(config);
};
export const throttleRelease = result => {
  resolveThrottle(getServiceName(result.config));
  return result;
};
export const throttleReleaseError = error => {
  resolveThrottle(getServiceName(error.config));
  return Promise.reject(error);
};
//# sourceMappingURL=throttle.js.map